import React from "react";
import {
    useRedirect,
    useRecordContext,
    useStore
} from "react-admin";
import { Button } from '@mui/material';
import { toSavedRepresentation } from "../utils/courseDelivery";

export const CourseInstanceLinkField = (props) => {
    const { courseCode, label, source } = props;
    const redirect = useRedirect();
    const record = useRecordContext();
    const [_, setCourseInstanceListParams] = useStore('CourseInstance.listParams');

    const courseDelivery = source || record;
    if (courseDelivery) {
        const onClick = (e) => {
            e.stopPropagation();
            setCourseInstanceListParams({
                displayedFilters: {},
                filter: {
                    q: source.quercusCode
                },
            });
            redirect('list', 'CourseInstance');
        };
        return <Button variant="contained" onClick={onClick}>{label}</Button>;
    }
    return null;
};

export const CourseInstanceCreateLink = (props) => {
    const { label, courseCode, isAssociateCourse, deliveryDetails } = props;
    const [_, setCourseInstanceCreateParams] = useStore('CourseInstance.createParams');
    const redirect = useRedirect();

    const onClick = () => {
        setCourseInstanceCreateParams({
            isAssociateCourse,
            courseCode,
            deliveryDetails
        });

        redirect('create', 'CourseInstance', null,{}, { record: {courseCode: courseCode, campusLocation: deliveryDetails.campusLocationId, quercusCode: deliveryDetails.quercusCode, courseDelivery: deliveryBuilder(deliveryDetails) } });
    };
    return <Button variant="contained" onClick={onClick} sx={{marginRight: '10px' }}>{label}</Button>;
};

const deliveryBuilder = (deliveryDetails) => {
    return `{'durationId': ${deliveryDetails.durationId}, 'modeOfStudyId': ${deliveryDetails.modeOfStudyId}, 'modeOfDeliveryId': ${deliveryDetails.modeOfDeliveryId}, 'campusLocationId': ${deliveryDetails.campusLocationId}, 'theDeliveryInstitutionID': ${deliveryDetails.theDeliveryInstitutionID}, 'quercusCode': ${deliveryDetails.quercusCode}, 'statusId': ${deliveryDetails.statusId}, 'shortCourse': ${deliveryDetails.shortCourse}}`
};